import React, { useState } from "react";
import { Button } from "react-bootstrap"
import Logo2 from "../../assets/images/BPPMHKP.png";
import './styles/landing.css';
import { useNavigate } from "react-router-dom";

const Navigation = () => {
  const [activeLink, setActiveLink] = useState("#features");

  const handleSetActive = (hash) => {
  if (hash === "#header") {
    setActiveLink(null); 
  } else {
    setActiveLink(hash);
  }
};;
 const navigate = useNavigate(); 

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <div className="container">
        <a className="navbar-brand" 
            href="#header" 
            style={{ display: 'flex', alignItems: 'center',fontWeight: 'bold', fontSize: '2rem'}}
            onClick={() => handleSetActive("#header")} >
              
          <img 
            src={Logo2}
            className="img-responsive" 
            style={{ width: '80px', marginRight: '10px', }}
            alt="Logo"
          />
          Badan Mutu KKP
        </a>
        
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto"> 
            <li className="nav-item " style={{ marginLeft: "20px" }}>
              <a 
                className={`nav-link ${activeLink === "#features" ? "active" : ""}`}
                href="#features"
                onClick={() => handleSetActive("#features")}
              >
                Fitur
              </a>
            </li>
            <li className="nav-item" style={{ marginLeft: "20px" }}>
              <a 
                className={`nav-link ${activeLink === "#about" ? "active" : ""}`}
                href="#about"
                onClick={() => handleSetActive("#about")}
              >
                Tentang
              </a>
            </li>
            <li className="nav-item" style={{ marginLeft: "20px" }}>
              <a 
                className={`nav-link ${activeLink === "#services" ? "active" : ""}`}
                href="#services"
                onClick={() => handleSetActive("#services")}
              >
                Tugas
              </a>
            </li>
            <li className="nav-item" style={{ marginLeft: "20px" }}>
              <Button as="a"
                className={`nav-link `}
                onClick={() => navigate("/login")}
                type="button"  variant="btn btn-primary"
              >
                Login
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
